"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _helpers = require("../../../../../../lib/helpers");

var _helpers2 = require("../../../../common/helpers");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable react-hooks/exhaustive-deps */
var ImageLayout = function ImageLayout(_ref) {
  var columns = _ref.columns,
      columnWidth = _ref.columnWidth,
      gutter = _ref.gutter,
      photos = _ref.photos,
      onImgClick = _ref.onImgClick,
      webpSupported = _ref.webpSupported,
      layoutWidth = _ref.layoutWidth,
      setLayoutWidth = _ref.setLayoutWidth;
  var getLayoutHeight = (0, _react.useMemo)(function () {
    var columnHeights = Array.from({
      length: columns
    }, function () {
      return 0;
    });
    photos.forEach(function (photo) {
      var minValue = Math.min.apply(Math, (0, _toConsumableArray2["default"])(columnHeights));
      var shortestColumnIndex = columnHeights.indexOf(minValue);
      var normalizedHeight = columnWidth / photo.width * photo.height;
      columnHeights[shortestColumnIndex] += normalizedHeight + gutter;
    });
    return Math.max.apply(Math, (0, _toConsumableArray2["default"])(columnHeights));
  }, [photos, columns, columnWidth, gutter]);
  (0, _react.useLayoutEffect)(function () {
    setLayoutWidth((0, _helpers2.generateLayoutWidth)(columns, columnWidth, gutter));
  }, [columns, columnWidth, gutter]);
  var renderPhotos = (0, _react.useMemo)(function () {
    var columnHeights = Array.from({
      length: columns
    }, function () {
      return 0;
    });
    photos.forEach(function (item) {
      var minValue = Math.min.apply(Math, (0, _toConsumableArray2["default"])(columnHeights));
      var shortestColumnIndex = columnHeights.indexOf(minValue);
      var left = (columnWidth + gutter) * shortestColumnIndex;
      var top = columnHeights[shortestColumnIndex];
      var normalizedHeight = columnWidth / item.width * item.height;
      columnHeights[shortestColumnIndex] += normalizedHeight + gutter; // eslint-disable-next-line no-param-reassign

      item.top = top; // eslint-disable-next-line no-param-reassign

      item.left = left;
    });
    return photos;
  }, [photos, columns, columnWidth, gutter]);
  var getLayoutWidth = (0, _react.useMemo)(function () {
    return columns * columnWidth + gutter * (columns - 1);
  }, [columnWidth, columns, gutter]); // FIXME(Pavel): Can't actually access photos becase divs with role not tabbable
  // related to how roles interact with elements:
  // https://github.com/jsx-eslint/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-noninteractive-tabindex.md

  var handleKeyPress = function handleKeyPress(event, index, photo) {
    if (event.key === 'Enter') {
      onImgClick(index, photo);
    }
  };

  var renderPhoto = function renderPhoto(photo, index) {
    var normalizedHeight = columnWidth / photo.width * photo.height; // Accounts for duplicate photos

    var key = "".concat(photo.id, "-").concat(index);
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: key,
      "aria-label": photo.name ? "Photo name ".concat(photo.name) : 'Photo without name',
      style: {
        top: "".concat(photo.top, "px"),
        left: "".concat(photo.left, "px"),
        position: 'absolute',
        width: "".concat(columnWidth, "px"),
        height: "".concat(normalizedHeight, "px"),
        overflow: 'hidden',
        cursor: 'pointer'
      },
      onClick: function onClick() {
        return onImgClick(index, photo);
      },
      onKeyPress: function onKeyPress(event) {
        return handleKeyPress(event, index, photo);
      }
    }, /*#__PURE__*/_react["default"].createElement("img", {
      key: "".concat(index, "-").concat(photo.width, "-").concat(photo.height),
      alt: photo.name || '',
      width: columnWidth,
      style: {
        height: '100%'
      },
      src: (0, _helpers.getImageByFormat)(photo, webpSupported),
      onContextMenu: function onContextMenu(e) {
        return e.preventDefault();
      }
    }));
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      position: 'relative',
      height: "".concat(getLayoutHeight, "px"),
      width: "".concat(layoutWidth || getLayoutWidth, "px")
    }
  }, renderPhotos.map(renderPhoto));
};

ImageLayout.defaultProps = {
  columns: 4,
  columnWidth: 100,
  gutter: 0,
  layoutWidth: 0,
  setLayoutWidth: function setLayoutWidth() {},
  onImgClick: function onImgClick() {},
  webpSupported: false
};
ImageLayout.propTypes = {
  columns: _propTypes["default"].number,
  columnWidth: _propTypes["default"].number,
  gutter: _propTypes["default"].number,
  photos: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    height: _propTypes["default"].number.isRequired,
    url: _propTypes["default"].string.isRequired,
    width: _propTypes["default"].number.isRequired
  })).isRequired,
  layoutWidth: _propTypes["default"].number,
  getLayoutWidth: _propTypes["default"].func,
  onImgClick: _propTypes["default"].func,
  webpSupported: _propTypes["default"].bool
};
var _default = ImageLayout;
exports["default"] = _default;